<template>
  <span v-show="$store.getters['app/overlays'].show_start_selector_overlay">
    <span id="text_title">Hoe speel je dit?</span>
    <span id="text_description">Selecteer een methode hoe je deze illustratie wilt starten. Dit is een virtuele omgeving hoe de mangrove zich voordoet.</span>
    <img  draggable="false" id="text_background" src="./../assets/images/Asset 36.png" alt="">
    <img  draggable="false"  @click="goToGameSelect()" id="play_start_btn" src="./../assets/images/Asset 37.png" alt="">
    <img  draggable="false" @click="goToHome()" id="top_quit_btn" src="./../assets/images/Asset 31.png" alt="">
  </span>
</template>

<script>

export default {
  name: "Start",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },

    goToGameSelect() {
      this.$router.push('/game_select');
    }
  },

  computed: {}
};
</script>

<style >
#play_start_btn {
	cursor: url('./../assets/cursor/material-wood-pointer.png'), default;	
	position: absolute;
	margin-top: 28%;
	left: 43%;
  width: 15%;
}
#text_background {
	position: absolute;
	margin-top: 4%;
	left: 22%;
  width: 55%;
  height: auto;
}
#text_title {
	font-family: 'LuckiestGuy';
	position: absolute;
	margin-top: 15%;
	left: 33%;
	color: white;
	z-index: 1;
  width: 35%;
	font-size: 3.5vw;
  text-align: center;
}
#text_description {
	font-family: 'LuckiestGuy';
	position: absolute;
	margin-top: 20%;
	left: 33%;
	color: white;
	z-index: 1;
	font-size: 1.5vw;
  width: 35%;
  text-align: center;
}

#play_start_btn:hover {
  opacity: 0.7;
}

#top_quit_btn:hover {
  opacity: 0.7;
}

#top_quit_btn {
  cursor: url('./../assets/cursor/material-wood-pointer.png'), default;	
	position: absolute;
	margin-top: 4%;
	right: 5%;
  width: 15%;
  z-index: 2;
}
</style>


